import { Link } from "react-router-dom";
import { ArrowIcon } from "../components/Icons";

export function NotFoundPage() {
  return (
    <section className="not-found">
      <div className="container">
        <p className="eyebrow eyebrow--light">404 · Page not found</p>
        <h1>Let’s get you back in the chair.</h1>
        <p>The page you were looking for has moved or no longer exists.</p>
        <Link className="button button--light" to="/">Return home <ArrowIcon /></Link>
      </div>
    </section>
  );
}
